export default __webpack_public_path__ + "static/media/goArrow.f6ef8366.svg";